import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const QUEUE_KEY = "mbca_queue_v1";

export const http = axios.create({ baseURL: API, timeout: 15000 });
export const ACCESS_KEY = "mbca_access_v1";
export const getAccess = () => localStorage.getItem(ACCESS_KEY) || "";
http.interceptors.request.use((cfg) => { const t = getAccess(); if (t) cfg.headers.Authorization = `Bearer ${t}`; return cfg; });
http.interceptors.response.use((r) => r, (e) => { if (e.response?.status === 401 && !String(e.config?.url).includes("/auth/pin")) { localStorage.removeItem(ACCESS_KEY); window.dispatchEvent(new Event("mbca-locked")); } return Promise.reject(e); });
export const loginPin = (pin) => http.post("/auth/pin", { pin }).then((r) => { localStorage.setItem(ACCESS_KEY, r.data.token); return r.data.token; });

export const readQueue = () => { try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch { return []; } };
const writeQueue = (q) => localStorage.setItem(QUEUE_KEY, JSON.stringify(q));

const isNetworkError = (e) => !e.response || e.code === "ECONNABORTED";

export async function mutate(method, path, data) {
  try {
    const res = await http.request({ method, url: path, data: data === undefined ? undefined : { data } });
    return { ok: true, data: res.data };
  } catch (e) {
    if (isNetworkError(e)) {
      writeQueue([...readQueue(), { method, path, data, at: Date.now() }]);
      return { ok: false, queued: true };
    }
    throw e;
  }
}

export async function flushQueue() {
  const q = readQueue();
  if (!q.length) return 0;
  const remaining = [];
  for (const op of q) {
    try {
      await http.request({ method: op.method, url: op.path, data: op.data === undefined ? undefined : { data: op.data } });
    } catch (e) {
      if (isNetworkError(e)) { remaining.push(op, ...q.slice(q.indexOf(op) + 1)); break; }
    }
  }
  writeQueue(remaining);
  return q.length - remaining.length;
}

export const fetchTrip = () => http.get("/trip").then((r) => r.data);
export const resetTrip = () => http.post("/trip/reset").then((r) => r.data);
export const askAssistant = (body) => http.post("/assistant", body, { timeout: 30000 }).then((r) => r.data);
